module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.value,
      "title": _vm.modalTitle,
      "mask-closable": false
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    }
  }, [_c('p', {
    staticClass: "schedule-desc"
  }, [_vm._v("可单选或同时勾选面试与试讲，分别选择日期时间。")]), _vm._v(" "), _c('div', {
    staticClass: "schedule-box"
  }, [_c('div', {
    staticClass: "schedule-row"
  }, [_c('Checkbox', {
    model: {
      value: (_vm.useInterview),
      callback: function($$v) {
        _vm.useInterview = $$v
      },
      expression: "useInterview"
    }
  }, [_vm._v("面试")]), _vm._v(" "), (_vm.useInterview) ? _c('DatePicker', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value": _vm.interviewTime,
      "placeholder": "选择面试日期与时间",
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.interviewTime = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "schedule-row"
  }, [_c('Checkbox', {
    model: {
      value: (_vm.useDemo),
      callback: function($$v) {
        _vm.useDemo = $$v
      },
      expression: "useDemo"
    }
  }, [_vm._v("试讲")]), _vm._v(" "), (_vm.useDemo) ? _c('DatePicker', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value": _vm.demoTime,
      "placeholder": "选择试讲日期与时间",
      "transfer": ""
    },
    on: {
      "on-change": function($event) {
        _vm.demoTime = $event
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (!_vm.useInterview && !_vm.useDemo) ? _c('p', {
    staticClass: "schedule-warn"
  }, [_vm._v("请至少勾选「面试」或「试讲」")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "disabled": !_vm.useInterview && !_vm.useDemo
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("确认安排")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7e2244a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/recruit/modal/RecruitScheduleModal.vue
// module id = 1984
// module chunks = 8